import React, { useContext } from 'react'
import { categoryEnum } from '../../../../../enums/makeRequestEnum'
import CardStep from '../../../../../components/modalStepper/step/CardStep'
import { MakeRequestContext } from '../../MakeRequestContext'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import styles from '../../../../../styles'
import { useMediaQuery } from 'react-responsive'
import { ClassValue } from 'classnames/types'
import { contractsPhaseEnum, propertyType, requestPurpose } from '../../../../../enums/contractsEnum'
import SvgPrivate from '../../../../../icons/Private'
import SvgCommon from '../../../../../icons/Common'
import { saveInteractions } from '../../../../gtm/utils/gtmCallback'
import fr from '../../../../../translations/fr'
import { useDispatch, useSelector } from 'react-redux'
import { displayModal } from '../../../../reducers/modal/actions'
import { modalTypes } from '../../../../../enums/modalTypeEnum'
import { canDisplayCustomAlert } from '../../../../../components/topAlert/utils/debitUtils'
import { RootState } from '../../../../reducers'
import { ContractsModel } from '../../../../../types/contracts/contractsModel'
import { estUnContractHopper } from '../../../../../utils/estContractHopper'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			cardContainerStyle: {
				width: '100%',
				margin: 0
			}
		}
	)
)

interface AcceptingProps {
	shouldSelectLease: boolean
}

const DEBIT = 'debit'
const DEPOSIT = 'deposit'
const ASSURANCE = 'assurance'
export const CONTRACT = 'contract'

const RequestPurpose: React.FC<AcceptingProps> = (
	{
		shouldSelectLease
	}
) => {
	const classes = useStyle()
	const theme = useTheme()
	const contracts = useSelector((state: RootState) => state.contracts)
	const requests = useSelector((state: RootState) => state.requests)
	const prelevement = useSelector((state: RootState) => state.prelevement)
	const dispatch = useDispatch()
	const { request, nextStep, setStep } = useContext(MakeRequestContext)
	const category = categoryEnum[request.requestType as keyof typeof categoryEnum]
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const cardContainerClass: ClassValue = classNames(
		'row',
		{
			[classes.cardContainerStyle]: !isLargeScreen
		}
	)

	const getBlocDescription = (card: string) => {
		const cardTypeClass = classNames(
			classes.text7
		)

		return (
			<>
				<h2 className={cardTypeClass}>
					<FormattedMessage
						id={`requests.makeRequest.step2.${card}`}
						defaultMessage={card}
						description="Card description"
					/>
				</h2>
			</>
		)
	}

	const getImg = (card: string) => {
		if (card === requestPurpose.private) {
			return <SvgPrivate color={theme.palette.blue.main} width={50} height={50} />
		} else if (card === requestPurpose.common) {
			return <SvgCommon color={theme.palette.blue.main} width={50} height={50} />
		}
	}

	const updateRequestPurpose = (text: string) => {
		if (text === DEBIT) {
			dispatch(displayModal(modalTypes.prelevement))
		} else if (text === DEPOSIT || text === ASSURANCE) {
			request.requestPurpose = CONTRACT
			saveInteractions(
				{
					category: 'Vos Demandes',
					action: 'Déposer une demande',
					// @ts-ignore
					label: `Etape 3::Bien concerné::${request.contract?.type === propertyType.apartment ? 'Appartement' : 'Parking'}::${fr[`requests.makeRequest.step1.${request.requestType}`]}::${fr[`requests.makeRequest.step2.${CONTRACT}`]}`
				}
			)

			request.requestConcern = text
			saveInteractions(
				{
					category: 'Vos Demandes',
					action: 'Déposer une demande',
					// @ts-ignore
					label: `Etape 4::Bien concerné::${request.contract?.type === propertyType.apartment ? 'Appartement' : 'Parking'}::${fr[`requests.makeRequest.step1.${request.requestType}`]}::${fr[`requests.makeRequest.step2.${request.requestPurpose}`]}::${fr[`requests.makeRequest.step3.${text}`]}`
				}
			)

			if (text === DEPOSIT) {
				setStep(shouldSelectLease ? 3 : 4)
			} else if (text === ASSURANCE) {
				if ((contracts as ContractsModel[]).filter((contract) => contract.type === propertyType.apartment).length > 1) {
					setStep(3)
				} else {
					setStep(4)
				}
			}
		} else {
			request.requestPurpose = text
			saveInteractions(
				{
					category: 'Vos Demandes',
					action: 'Déposer une demande',
					// @ts-ignore
					label: `Etape 3::Bien concerné::${request.contract?.type === propertyType.apartment ? 'Appartement' : 'Parking'}::${fr[`requests.makeRequest.step1.${request.requestType}`]}::${fr[`requests.makeRequest.step2.${text}`]}`
				}
			)


			nextStep()
		}
	}

	return (
		<div className={cardContainerClass}>
			{
				Object.getOwnPropertyNames(category).map(
					(card) => {
						if (card !== DEBIT && card !== DEPOSIT && card !== ASSURANCE) {
							return (
								<CardStep
									key={card}
									blocDescription={getBlocDescription(card)}
									img={getImg(card)}
									setSelected={() => updateRequestPurpose(card)}
								/>
							)
						}

						if (prelevement.subscribePrelevementModal && canDisplayCustomAlert(contracts, requests) && card === DEBIT) {
							return (
								<CardStep
									key={card}
									blocDescription={getBlocDescription(card)}
									img={getImg(card)}
									setSelected={() => updateRequestPurpose(card)}
								/>

							)
						}
						if (card === DEPOSIT && (contracts as ContractsModel[]).filter((contract) => (contract.phase === contractsPhaseEnum.exploitation && !estUnContractHopper(contract.portefeuille))).length > 0) {
							return (
								<CardStep
									key={card}
									blocDescription={getBlocDescription(card)}
									img={getImg(card)}
									setSelected={() => updateRequestPurpose(card)}
								/>

							)
						}
						if (card === ASSURANCE && (contracts as ContractsModel[]).filter((contract) => (contract.phase === contractsPhaseEnum.exploitation && contract.type === propertyType.apartment)).length > 0) {
							return (
								<CardStep
									key={card}
									blocDescription={getBlocDescription(card)}
									img={getImg(card)}
									setSelected={() => updateRequestPurpose(card)}
								/>

							)
						}

						return <React.Fragment key={card}></React.Fragment>
					}
				)
			}
		</div>
	)
}

export default RequestPurpose
